const en = {
  state: {
    expression_1: 'Avatar',
    expression_2: 'Campaign',
    expression_3: 'Campaigns',
    expression_4: 'Channel',
    expression_5: 'Channels',
    expression_6: 'Choose a channel...',
    expression_7: 'Choose a channel...',
    expression_8: 'Choose a channel to view the graph.',
    expression_9: 'Select an option...',
    expression_10: 'Clear notifications',
    expression_11: 'Indicators',
    expression_12: 'Team',
    expression_13: 'Teams',
    expression_14: 'Download chart',
    expression_15: 'Duration',
    expression_16: 'Engagement',
    expression_17: 'Closed by',
    expression_18: 'Closed in',
    expression_19: 'Closed (today)',
    expression_20: 'Protocols completed today',
    expression_21: 'Closed',
    expression_22: 'Closed this week',
    expression_23: 'Funnel',
    expression_24: 'optional',
    expression_25: 'Funnels',
    expression_26: 'The business rules below are only available to BEECRM plan customers. Get in touch with our commercial team and hire now!',
    expression_27: 'Learn how to activate',
    expression_28: 'id',
    expression_29: 'In Service',
    expression_30: 'Protocols in attendance',
    expression_31: 'Interest',
    expression_32: 'Interests',
    expression_33: 'Latest conversations',
    expression_34: 'Contact',
    expression_35: 'Contacts',
    expression_36: 'Loading...',
    expression_37: 'Logout',
    expression_38: 'Chat',
    expression_39: 'Lost deals this month',
    expression_40: 'My profile',
    expression_41: 'Profile',
    expression_42: 'Name',
    expression_43: 'No existing goals.',
    expression_44: 'No protocol found',
    expression_45: 'Notification',
    expression_46: 'Notifications',
    expression_47: 'Qualifications',
    expression_48: 'Agent',
    expression_49: 'Agents',
    expression_50: 'Operators',
    expression_51: 'Operators',
    expression_52: 'Dashboard',
    expression_53: 'Performance',
    expression_54: 'Contact',
    expression_55: 'Protocol',
    expression_56: 'Qualification',
    expression_57: 'Qualifications',
    expression_58: 'Report',
    expression_59: 'Reports',
    expression_60: 'Search',
    expression_61: 'Seconds',
    expression_62: 'Settings',
    expression_63: 'View more',
    expression_64: 'View report',
    expression_65: 'Last name',
    expression_66: 'Started in',
    expression_67: 'Status',
    expression_68: 'Assignment',
    expression_69: 'Tasks',
    expression_70: 'Is Portuguese!',
    expression_71: 'This month',
    expression_72: 'Protocol',
    expression_73: 'Conversations',
    expression_74: 'Connect to Official WhatsApp API',
    expression_75: 'AST',
    expression_76: 'Average service time',
    expression_77: 'ATB',
    expression_78: 'Average time in chat-bot',
    expression_79: 'AWT',
    expression_80: 'Average waiting time',
    expression_81: 'Agent',
    expression_82: 'Users',
    expression_83: 'Waiting',
    expression_84: 'Protocols awaiting service',
    expression_85: 'Organización',
    expression_86: 'Trades won this month',
    expression_87: 'In negociation',
    expression_88: 'Gain',
    expression_89: 'Lost',
    expression_90: 'Average',
    expression_91: 'Your search results will be displayed below.',
    expression_92: 'Contact information',
    expression_93: 'Details',
    expression_94: 'Manage system users',
    expression_95: 'User Details',
    expression_96: 'Edit user settings',
    expression_97: 'Register and manage your communication channels',
    expression_98: 'Edit the settings of your channel',
    expression_99: 'Campaigns',
    expression_100: 'Create campaign',
    expression_101: 'Edit publication settings',
    expression_102: 'Adresses',
    expression_103: 'Engagement Report',
    expression_104: 'URL\'s',
    expression_105: 'Performance Report',
    expression_106: 'Conversations Report',
    expression_107: 'Start registering or managing your tasks',
    expression_108: "Displays the Operator Name in messages that have been sent",
    expression_109: 'Import leads',
    expression_110: 'Insert contact',
    expression_111: 'Identifies agent',
    expression_112: 'Export leads',
    expression_113: 'Back',
    expression_114: 'Search for user',
    expression_115: 'Register user',
    expression_116: 'Records found',
    expression_117: 'Record found',
    expression_118: 'Register channel',
    expression_119: 'Search for a channel',
    expression_120: 'Save',
    expression_121: '31 day limit',
    expression_122: 'Export Excel',
    expression_123: 'All channels',
    expression_124: 'Choose a department...',
    expression_125: 'Choose a department',
    expression_126: 'Choose an attendant',
    expression_127: 'All attendants',
    expression_128: 'Search leads',
    expression_129: 'Search Conversations',
    expression_130: 'Export PDF',
    expression_131: 'To view records, perform a search',
    expression_132: 'Updated in',
    expression_133: 'To view results, select a channel',
    expression_134: 'Help',
    expression_135: 'Add new task',
    expression_136: 'Leads',
    expression_137: 'Verified',
    expression_138: 'Verified',
    expression_139: 'Do not have an account',
    expression_140: 'Does not have an account',
    expression_141: 'Not Verified',
    expression_142: 'Not Verified',

    expression_143: 'No e-mail registered',
    expression_144: 'Unsubscribe date',
    expression_145: 'Evaluation',
    expression_146: 'No tags were linked.',
    expression_147: 'Drag the options to the side',
    expression_148: 'No contact found',
    expression_149: 'Notes',
    expression_150: 'Tags',
    expression_151: 'Tag',
    expression_152: 'Wallet',
    expression_153: 'Wallets',
    expression_154: 'Woman',
    expression_155: 'Man',
    expression_156: 'Registration date',
    expression_157: 'Start Conversation',
    expression_158: 'Negotiation',
    expression_159: 'Registration date',
    expression_160: 'Newsletter',
    expression_161: 'E-mail',
    expression_162: 'Unregistered email',
    expression_163: 'Unsubscribed in',
    expression_164: 'Registration in',
    expression_165: 'Evaluation (NPS)',
    expression_166: 'Information',
    expression_167: 'Edit',
    expression_168: 'Document',
    expression_169: 'Not registered',
    expression_170: 'Uninformed',
    expression_171: 'Not registered',
    expression_172: 'Not informed',
    expression_173: 'Business Profile',
    expression_174: 'Post',
    expression_175: 'Name of the street',
    expression_176: 'Zip code',
    expression_177: 'City',
    expression_178: 'Number',
    expression_179: 'Neighborhood',
    expression_180: 'State',
    expression_181: 'Reference point',
    expression_182: 'Country',
    expression_183: 'Type of note',
    expression_184: 'Create an annotation',
    expression_185: 'Write something...',
    expression_186: 'No annotation created.',
    expression_187: 'Available Tags',
    expression_188: 'Click on tag name to link',
    expression_189: 'No linked tags.',
    expression_190: 'Download file',
    expression_191: 'Operator',
    expression_192: 'NPS',
    expression_193: 'Protocol number',
    expression_194: 'Sold!',
    expression_195: 'Not sold',
    expression_196: 'No protocol has been registered.',
    expression_197: 'Linked attendant',
    expression_198: 'Action',
    expression_199: 'Transfer Contact',
    expression_200: 'Remove',
    expression_201: 'No agent assigned to this lead.',
    expression_202: 'Choose a channel and department to view frames.',
    expression_203: 'Documents',
    expression_204: 'You have reached the limit of users on this channel.!',
    expression_205: 'In progress',
    expression_206: 'Closed',
    expression_207: 'Generate a QRCode',
    expression_208: 'Hello :operator_name, are you there?',
    expression_209: "If you don't confirm, you will be disconnected within 5 minutes!",
    expression_210: 'Yes I am here!',
    expression_211: 'By clicking Continue, you agree to the',
    expression_212: 'Meta Terms for Whatsapp Business',
    expression_213: 'Error checking number',
    expression_214: 'Please contact support and inform the <strong>Error code: 1001</strong>',
    expression_215: 'total',
    expression_216: 'sent',
    expression_217: 'Phone does not have WhatsApp',
    expression_218: 'It is not possible to add or open a ticket with this phone as it does not have a Whatsapp account',
    expression_219: 'Messages sent',
    expression_220: 'Messages Received',
    expression_221: 'Inbox',
    expression_222: 'Password',
    expression_223: 'Show password',
    expression_224: 'Hide password',
    expression_225: 'Create new password',
    expression_226: 'I forgot the password',
    expression_227: 'Login in',
    expression_228: 'Email verified successfully!',
    expression_229: 'Go to dashboard',
    expression_230: 'Invalid link!',
    expression_231: 'It appears that the link you are trying to access is no longer available.',
    expression_232: 'Back to start',
    expression_233: 'Search for a name or phone.',
    expression_234: 'Unavailable',
    expression_235: 'Last seen',
    expression_236: 'Blocked channel',
    expression_237: 'Online Channel',
    expression_238: 'Offline Channel',
    expression_239: 'No channels have been registered so far.',
    expression_240: 'Save editions',
    expression_241: 'Parameters',
    expression_242: 'Opening Hours',
    expression_243: 'Protocol Qualification',
    expression_244: 'Quick Answers',
    expression_245: 'Your campaign will be running in no time!',
    expression_246: 'Self service',
    expression_247: 'Activation',
    expression_248: 'Integrations',
    expression_249: 'Website Widget',
    expression_250: 'Templates HSM',
    expression_251: 'Plans and additional',
    expression_252: 'You have reached the limit of some features.',
    expression_253: 'Total campaigns',
    expression_254: 'Completed campaigns',
    expression_255: 'Scheduled campaigns',
    expression_256: 'Ongoing campaigns',
    expression_257: 'Campaign Type',
    expression_258: 'Transmission list',
    expression_259: 'Creation date',
    expression_260: 'Shipping date',
    expression_261: 'Text preview',
    expression_262: 'Closed',
    expression_263: 'Media',
    expression_264: 'Text',
    expression_265: 'Shipping metrics',
    expression_266: 'Metrics',
    expression_267: 'Completed list(s)',
    expression_268: 'Target Audience',
    expression_269: 'All valid leads',
    expression_270: 'No campaigns have been created so far..',
    expression_271: 'Orientations',
    expression_272: 'To proceed with creating your campaign, you must agree to the following terms:',
    expression_273: 'For your safety, never run two or more campaigns simultaneously. This can result in permanent banning of your number.',
    expression_274: 'Only click "Save Post" if you are sure all settings are correct.',
    expression_275: 'Messages using a transmission list will only be forwarded to users who add their phone number to their phonebook and have already communicated at least once on WhatsApp within the system.',
    expression_276: 'As much as possible, avoid importing lists of contacts who have never communicated with the system and who do not have their number saved in the phonebook. WhatsApp validates the lists and may not send it if it detects that its members have never communicated or that their contact is not saved. This can impact those who comply with the rules.',
    expression_277: 'The shipping time becomes very important so that the lead does not reject your transmissions. The proper time for sending a mass broadcast is between 8:00 am and 6:00 pm.',
    expression_278: 'Please note that frequent use of mass broadcasting can lead to leads reporting your messages as SPAM.',
    expression_279: 'Continue',
    expression_280: 'Publish in',
    expression_281: 'Select all',
    expression_282: 'No channels available for campaign.',
    expression_283: 'Campaign Type',
    expression_284: 'Choose your campaign type: Broadcast List or Status',
    expression_285: 'Choose an option...',
    expression_286: 'All leads',
    expression_287: 'Send to tags',
    expression_288: 'Shot content',
    expression_289: 'Write campaign content. You can attach a media or schedule the publication to be sent.',
    expression_290: "Sending method",
    expression_291: 'Schedule what will be sent automatically when the lead sends a message.',
    expression_292: 'Immediate dispatch',
    expression_293: 'Scheduled shipping',
    expression_294: 'If you choose this option, the presentation message will be replaced by the media you send here.',
    expression_295: 'Introduction Message (Welcome)',
    expression_296: 'Add one more',
    expression_297: 'Remove media',
    expression_298: 'Add emoji',
    expression_299: 'Status campaigns containing text only will have random background colors. The colors shown here are for illustrative purposes only.',
    expression_300: "Message preview",
    expression_301: 'Your message will appear here...',
    expression_302: 'My status',
    expression_303: 'Generate campaign',
    expression_304: 'Indicate which contacts should receive the campaign.',
    expression_305: 'Call in progress...',
    expression_306: 'Calling...',
    expression_307: 'End call',
    expression_308: 'Unmute',
    expression_309: 'Mute',
    expression_310: 'Do you want to delete all notifications?',
    expression_311: 'This action is irreversible.',
    expression_312: 'Attendance',
    expression_313: 'By pausing the campaign you can resume it later.',
    expression_314: 'Total Protocols',
    expression_315: 'Protocols Awaiting',
    expression_316: 'Closed Protocols',
    expression_317: 'Closed',
    expression_318: 'Rejected Protocols',
    expression_319: 'Rejected',
    expression_320: 'Daily metrics (this month)',
    expression_321: 'Select a channel to view the report.',
    expression_322: 'No origin was registered in this channel.',
    expression_323: 'Total channels that had unique leads',
    expression_324: 'Total departments that had unique leads',
    expression_325: 'Total attendants',
    expression_326: 'Total unique leads this month',
    expression_327: 'Contacts (this month)',
    expression_328: 'Total unique leads in the last month',
    expression_329: 'Contacts (previous month)',
    expression_330: 'Channel Name',
    expression_331: 'We did not find any data for this filter...',
    expression_332: 'Choose a channel, a department and/or an agent to view the detailed report.',
    expression_333: 'Registered contacts (month)',
    expression_334: 'TOTAL',
    expression_335: 'No service has been performed so far.',
    expression_336: 'Add submenu',
    expression_337: 'Hidden option',
    expression_338: 'Visible option',
    expression_339: 'Delete option',
    expression_340: 'Close',
    expression_341: 'Option',
    expression_342: 'Enter the number corresponding to this option..',
    expression_343: 'Subtitle',
    expression_344: 'Enter the title or caption for this option..',
    expression_345: 'Key words',
    expression_346: 'Use the field below so that the lead can identify the menu with keywords, always separated by a comma.',
    expression_347: 'E.g: "receive offers, yes, I want to receive"',
    expression_348: 'Message (text and/or media)',
    expression_349: 'Type a message or attach media to be sent to the contact.',
    expression_350: 'Choose the TAG that the contact will be automatically linked.',
    expression_351: 'Define if contacts will automatically be subscribed to the Newsletter.',
    expression_352: 'No option created.',
    expression_353: 'Do you really want to perform this action?',
    expression_354: 'yes, proceed',
    expression_355: 'Cancel',
    expression_356: 'Organization Settings',
    expression_357: 'Click to lock channel',
    expression_358: 'Block',
    expression_359: 'Click to unlock the channel',
    expression_360: 'Unlock',
    expression_361: 'Clear messages',
    expression_362: 'Click to clear messages from the submission queue',
    expression_363: 'Department',
    expression_364: 'Name',
    expression_365: 'Complement / Reference',
    expression_366: 'Business rules',
    expression_367: 'Attendance Human',
    expression_368: 'API',
    expression_369: 'Business rules',
    expression_370: 'Register contact',
    expression_371: 'Hide contact',
    expression_372: 'Message transfer',
    expression_373: 'Automatic Distribution',
    expression_374: 'Use this QR Code in your marketing campaigns to drive your visitors to the WhatsApp app. The visitor does not need to download any other application, just point the cell phone camera at the image.',
    expression_375: 'Download your WhatsApp QR-code below:',
    expression_376: 'Download',
    expression_377: 'Use this QR Code to get your visitors to add this channels phone number to their cell phone calendars. The visitor does not need to download any other application, just point the cell phone camera at the image.',
    expression_378: 'Download your QR-code for V-Card below:',
    expression_379: 'Add media',
    expression_380: 'Variables and Formatting',
    expression_381: 'tips:',
    expression_382: 'Use the variable',
    expression_383: 'To display the leads name in the message. Display words in bold using',
    expression_384: 'before and after the desired text. E.g, type:',
    expression_385: 'Result',
    expression_386: 'Bot Menus',
    expression_387: 'Configure the options that will be displayed to the contact. The lead must enter the desired option to be directed to a department or content you determine below.',
    expression_388: 'Add to main menu',
    expression_389: 'Support',
    expression_390: 'Hello',
    expression_391: 'I am',
    expression_392: 'artificial intelligence by',
    expression_393: 'I am prepared to serve your customers, answer questions and send offers.',
    expression_394: 'Configure my options in the menu on the side.',
    expression_395: 'Configure your chat bot options',
    expression_396: 'Add department',
    expression_397: 'Record limit exceeded',
    expression_398: 'You can create specific departments to direct your work flow. Then establish a “Service Schedule” where you will set the hours of operation. Then link some users as attendants or set up a "chat bot" to start moving your calls.',
    expression_399: 'Click here to learn more.',
    expression_400: 'Department Name',
    expression_401: 'You cannot delete the default department.',
    expression_402: 'The user is not registered as an attendant.',
    expression_403: 'Finished',
    expression_404: 'Add step',
    expression_405: "You must have at least one 'Interest', one 'Qualification' and one 'Protocol Source' registered.",
    expression_406: 'Attention!',
    expression_407: 'Would you like to send the message anyway?',
    expression_408: 'Please enter a start date and end date for your campaign search.',
    expression_409: 'No steps registered.',
    expression_410: 'Add template',
    expression_411: 'Model name',
    expression_412: 'Category',
    expression_413: 'Preview',
    expression_414: 'Languages',
    expression_415: 'Approved',
    expression_416: 'Disapproved',
    expression_417: 'Sent',
    expression_418: 'Pending',
    expression_419: 'No interest registered.',
    expression_420: 'Do you want to delete this template?',
    expression_421: 'Yes, delete',
    expression_422: 'Communications',
    expression_423: 'You need to configure the integration before enabling it.',
    expression_424: 'Settings',
    expression_425: 'Active',
    expression_426: 'Inactive',
    expression_427: 'You need to enter a token!',
    expression_428: 'You are not allowed to change!',
    expression_429: 'Add interest',
    expression_430: 'Define here the possible interests that may bring your leads to the service. The "interests" can be as varied as the products or services your company offers. For example, in the case of a car store, we could identify interests such as: "New Cars, Used Cars and Auto Parts".',
    expression_431: 'Name of Interest',
    expression_432: "You must have at least one 'Interest' when the funnel is enabled.",
    expression_433: 'Add qualification',
    expression_434: 'Skills help generate reports and metrics to improve decision making across your organization. Operators can qualify protocols according to the subject covered in each protocol created. For example: "Doubt, Suggestion, Mistake".',
    expression_435: 'Qualification Name',
    expression_436: "You must have at least one 'Qualification' when the funnel is enabled.",
    expression_437: 'No qualifications registered.',
    expression_438: 'Opening',
    expression_439: 'Closing',
    expression_440: 'Monday',
    expression_441: 'Tuesday',
    expression_442: 'Wednesday',
    expression_443: 'Thursday',
    expression_444: 'Friday',
    expression_445: 'Saturday',
    expression_446: 'Sunday',
    expression_447: 'Add attendant',
    expression_448: 'Once you have created departments and defined their service roster, you all be able to link your users as agents for that channel. This way, these users will have access to the "Chat" in real time with the leads, according to the service flow defined by you.',
    expression_449: 'Operator Name',
    expression_450: 'No attendant registered.',
    expression_451: 'Timing',
    expression_452: 'Idle Time (Operator)',
    expression_453: 'Set the maximum time your agents must respond to a call. An alert will be displayed to the agent within the timeframe you stipulate below so that he can continue the open service.',
    expression_454: 'minutes',
    expression_455: 'Idle time Auto attendant',
    expression_456: 'Set the maximum amount of time you want to wait for a response from your lead on CHATBOT. BOT will send a message and automatically close the protocol when it reaches the period you enter below.',
    expression_457: 'Idle Time (Contact)',
    expression_458: 'Set a time limit to wait for an interaction from your lead. An automatic message will be sent and the protocol will be closed automatically when it reaches the period informed below.',
    expression_459: 'Idle Time Protocol',
    expression_460: 'Set a window of time that the system will ignore new lead messages after a protocol closes. Inform below how long.',
    expression_461: 'Idle time Invalid attempts',
    expression_462: 'Set the maximum number of invalid attempts a lead can enter into CHATBOT. An automatic message will be sent and the protocol will be closed when it reaches the amount informed below.',
    expression_463: 'times',
    expression_464: 'System messages',
    expression_465: 'Schedule automatic messages that will be sent according to the stage of service.',
    expression_466: 'Welcome',
    expression_467: 'This text will be sent whenever your channel receives the first message from a lead.',
    expression_468: "E.g: 'Hello, {{NOME}}! Thank you for contacting us. We will already start your service.'",
    expression_469: 'Closure',
    expression_470: 'Message that will be sent whenever a protocol is finalized.',
    expression_471: "E.g: 'We appreciate your contact. See you soon!'",
    expression_472: 'Operator Inactivity',
    expression_473: "This alert message will be displayed to your attendant, respecting the deadline you set in the 'Idle Time (Operator)'",
    expression_474: "E.g: 'Attention! You need to continue the call or end it.'",
    expression_475: "This message will be displayed to your lead when it stops interacting with the channel, respecting the deadline you set in the 'Contact Time' timing'",
    expression_476: 'Contact Inactivity',
    expression_477: "E.g: 'Due to lack of interaction, the service was terminated. Return whenever you wish.'",
    expression_478: "E.g: 'Due to lack of interaction, the service was terminated. Return whenever you wish.'",
    expression_479: "Inactivity self-service",
    expression_480: "This message will be displayed to your lead when it stops interacting with the BOT, respecting the deadline you set in the 'Idle Time (Chat-Bot) timing'",
    expression_481: "E.g: 'We appreciate the contact and we're willing to do it.'",
    expression_482: "Horario de atención",
    expression_483: "This message will be sent to the leads that interact with the channel outside the opening hours informed in the 'SERVICE SCALE' of each department.",
    expression_484: "Dear customer, we are finished with the service for today. Our hours of operation are Monday to Friday, 9am to 6pm.",
    expression_485: "Satisfaction Survey",
    expression_486: "This message will be sent to the lead asking them to respond to a satisfaction survey regarding the service.",
    expression_487: "Having you as a customer motivates us to always offer the best services. Click on the link and rate our service.",
    expression_488: "Closing Research",
    expression_489: "Message that will be displayed when the customer answers the satisfaction survey.",
    expression_490: "Thanks for answering! With your help, we can increasingly improve our service.",
    expression_491: 'Edit plan',
    expression_492: 'Cancel edit',
    expression_493: 'Functions',
    expression_494: 'The amount',
    expression_495: 'Used',
    expression_496: 'Limit exceeded! If you need more, look for your consultant and hire.',
    expression_497: 'Information updated every 1 (one) hour.',
    expression_498: 'Yes',
    expression_499: 'No',
    expression_500: 'Quick Answers',
    expression_501: 'Add an answer',
    expression_502: 'Records Limit Exceeded',
    expression_503: "Standardize and automate the submission of responses with the help of this feature. You will be able to define specific texts for each department and enrich the messages by attaching images. These responses will be displayed to the attendants in the 'Chat'.",
    expression_504: 'Shortcut / Bookmark',
    expression_505: 'Message',
    expression_506: 'Image',
    expression_507: 'No response registered.',
    expression_508: 'Pause',
    expression_509: 'Resume',
    expression_510: 'All kinds',
    expression_511: 'Opportunities',
    expression_512: "Gallery",
    expression_513: "HSM",
    expression_514: "Add tag",
    expression_515: 'Tags are used to group several leads in a given classification. With the help of this feature you will be able to segment your marketing campaigns or get more detailed reports. Example: Prospects, Customers, Employees, etc.',
    expression_516: "Tag Name",
    expression_517: "No tags registered.",
    expression_518: "Widget Texts",
    expression_519: "Use this space to entice your visitors with a short message.",
    expression_520: "Widget Title",
    expression_521: "Greeting message",
    expression_522: "Completion message",
    expression_523: "Customize the style",
    expression_524: "Use this space to entice your visitors with a short message.",
    expression_525: "Position",
    expression_526: "Right side",
    expression_527: "Left side",
    expression_528: "Button color",
    expression_529: "remove image",
    expression_530: "Attach file",
    expression_531: "Insert this code on your website",
    expression_532: "Copy the code below and paste it on your website, inside the tag",
    expression_533: "Widget preview",
    expression_534: "Sending SMS",
    expression_535: "Voip connection",
    expression_536: "Sending HSM",
    expression_537: "Start",
    expression_538: "Transfer",
    expression_539: "Continue protocol",
    expression_540: "Pause Protocol",
    expression_541: "Finish",
    expression_542: "Other options",
    expression_543: "Contact",
    expression_544: "Location",
    expression_545: "Beta",
    expression_546: "History",
    expression_547: "Variables",
    expression_548: "Info",
    expression_549: "Minimize",
    expression_550: "Details",
    expression_551: "No quick answers found.",
    expression_552: "Emojis",
    expression_553: "Attach file",
    expression_554: "This lead does not have a valid account on WhatsApp",
    expression_555: "You do not have an open interaction with this lead.",
    expression_556: "Type something or / to access quick answers...",
    expression_557: "Recording audio...",
    expression_558: "Gravar",
    expression_559: "Send Message",
    expression_560: "Send message templates",
    expression_561: "Stop recording",
    expression_562: "To send",
    expression_563: "Delete recording",
    expression_564: "Contact Information",
    expression_565: "Profile",
    expression_566: "Gender",
    expression_567: "Undefined",
    expression_568: "Feminine",
    expression_569: "Masculine",
    expression_570: "Enter your note...",
    expression_571: "No notes.",
    expression_572: "Trading Value",
    expression_573: "Trading won",
    expression_574: "Lost negotiation",
    expression_575: "Description",
    expression_576: "No interest",
    expression_577: "No qualifications",
    expression_578: "No origin",
    expression_579: "Search for lead in chat...",
    expression_580: "Search for lead in calendar...",
    expression_581: "Search the calendar",
    expression_582: "You don't have active chats!",
    expression_583: "Once a new conversation is started it will appear here.",
    expression_584: "You need to confirm your email address.",
    expression_585: "Resend confirmation email",
    expression_586: "WAITING",
    expression_587: "Answering",
    expression_588: "ANSWERING",
    expression_589: "Paused",
    expression_590: "PAUSED",
    expression_591: "Out of hours",
    expression_592: "Classification",
    expression_593: "Negotiations",
    expression_594: "No notifications.",
    expression_595: "Channel type",
    expression_596: "Choose a type...",
    expression_597: "Create channel",
    expression_598: "Choose a user...",
    expression_599: "Register new channel",
    expression_600: "Add attendant to channel",
    expression_601: "Campaign paused",
    expression_602: "Step name",
    expression_603: "Start date",
    expression_604: "Due date",
    expression_605: "Choose an attendant...",
    expression_606: 'Register new lead',
    expression_607: 'Read the instructions below before registering a new lead! If you enter numbers without following this pattern, you may have duplicate protocols and leads within the system. These are express rules of the WhatsApp application.',
    expression_608: 'How to register',
    expression_609: 'To register a lead in',
    expression_610: 'use the international numeric standard, including DDI (country code) and area code (for example: 5511988776655), without spaces or any other types of characters. If you do not follow these standards, you will not be able to contact the lead.',
    expression_611: 'Ninth digit for WhatsApp',
    expression_612: 'Only numbers from the states of ES, RJ and SP can receive the ninth digit. Numbers from other states',
    expression_613: 'must be entered using the ninth digit.',
    expression_614: 'Examples',
    expression_615: 'With the ninth digit',
    expression_616: 'Without the ninth digit',
    expression_617: 'This field is required',
    expression_618: 'Required fields',
    expression_619: 'This lead is already registered in this channel and has an open protocol.',
    expression_620: 'This lead is already registered on this channel!',
    expression_621: 'Open protocol',
    expression_622: 'I accept and I want to continue',
    expression_623: 'Fill in the fields above',
    expression_624: 'This lead does not belong to you.',
    expression_625: 'You need to select a channel and a department.',
    expression_626: 'link attendant',
    expression_627: 'You have exceeded your registered attendant limit.',
    expression_628: 'Add quick reply',
    expression_629: 'Marking',
    expression_630: 'Tags help organize your answers.',
    expression_631: 'Message Content',
    expression_632: 'Click to attach a file.',
    expression_633: 'Allowed types: JPG, JPEG or PNG.',
    expression_634: 'The maximum size per file is 15MB.',
    expression_635: 'Task name',
    expression_636: 'Recipients name',
    expression_637: 'Choose a recipient...',
    expression_638: 'Priority',
    expression_639: 'Choose a priority...',
    expression_640: 'Save task',
    expression_641: 'Create HSM template',
    expression_642: 'Examples will be uploaded to Facebook as part of the template approval process. If no examples are provided, templates may be rejected by Facebook.',
    expression_643: 'Required field',
    expression_644: 'Names must always be in lowercase, numbers and/or underlined. Special characters are not accepted.',
    expression_645: 'Message category',
    expression_646: 'Choose a category...',
    expression_647: 'Language',
    expression_648: 'Choose a language...',
    expression_649: 'Select template building blocks',
    expression_650: 'Header',
    expression_651: 'Body',
    expression_652: 'Baseboard',
    expression_653: 'Buttons',
    expression_654: 'Enter your template header text here...',
    expression_655: 'characters',
    expression_656: 'variable',
    expression_657: 'Enter the main text of your template...',
    expression_658: 'Enter your template footer text here...',
    expression_659: 'Add button',
    expression_660: 'Button',
    expression_661: 'Quick answer',
    expression_662: 'Enter the quick reply text...',
    expression_663: 'Enter the text for the button...',
    expression_664: 'Enter the phone number...',
    expression_665: 'Enter the text of the CTA...',
    expression_666: 'Enter the URL...',
    expression_667: 'Choose the type and add a button.',
    expression_668: 'Sample Template',
    expression_669: 'You do not use any variables. This can affect the approval of your template with Facebook.',
    expression_670: 'Url button',
    expression_671: 'Template Preview',
    expression_672: 'Your header will appear here...',
    expression_673: 'Your footer will appear here...',
    expression_674: 'Your template has been submitted for approval!',
    expression_675: 'Facebook may take up to',
    expression_676: '5 working days',
    expression_677: 'to approve your HSM template.',
    expression_678: 'see preview',
    expression_679: 'Fill in the required fields',
    expression_680: 'Save and continue',
    expression_681: 'The maximum size allowed per file is {size}.',
    expression_682: 'Check the file',
    expression_683: 'Attention!',
    expression_684: 'File type not allowed.',
    expression_685: 'Allowed type: PDF.',
    expression_686: 'Register new user',
    expression_687: 'Access level',
    expression_688: 'Supervisor',
    expression_689: 'Administrator',
    expression_690: 'Save user',
    expression_691: 'Add Contact to Wallet',
    expression_692: 'No attendant...',
    expression_693: 'Add',
    expression_694: 'Send email',
    expression_695: 'Recipient:',
    expression_696: 'Delete',
    expression_697: 'The response to any email sent by the system will arrive in your mailbox:',
    expression_698: 'Make sure this mailbox is valid and accessible for you.',
    expression_699: 'Subject',
    expression_700: 'Campaign resumed',
    expression_701: 'Trading Status',
    expression_702: 'Fill in all fields above.',
    expression_703: 'Send media',
    expression_704: 'Click or drag the files here.',
    expression_705: 'Allowed types: JPG, JPEG, PNG, WEBP, PDF, MP3, DOC, DOCX, XLS and XLSX.',
    expression_706: 'Subtitle...',
    expression_707: 'Protocol History',
    expression_708: 'Date',
    expression_709: 'No protocol history available.',
    expression_710: 'Send Location',
    expression_711: 'Type the address and press enter or click search',
    expression_712: 'Search',
    expression_713: 'Protocol information',
    expression_714: 'Send SMS',
    expression_715: 'Enter the message:',
    expression_716: 'Transfer protocol',
    expression_717: 'Send V-card',
    expression_718: 'Edit department',
    expression_719: 'Do you want to pause this campaign?',
    expression_720: 'Edit goal',
    expression_721: 'Delete goal',
    expression_722: 'Edit interest',
    expression_723: 'Edit contact',
    expression_724: 'Edit Qualification',
    expression_725: 'Edit plan settings',
    expression_726: 'Select admin email',
    expression_727: 'Select a contact...',
    expression_728: 'Enter 4-digit code',
    expression_729: 'Code successfully validated!',
    expression_730: 'Invalid code!',
    expression_731: 'Submit verification code',
    expression_732: 'Resend code',
    expression_733: 'Validate!',
    expression_734: 'Edit Quick Reply',
    expression_735: 'Your campaign will be running in no time!',
    expression_736: 'Edit tag',
    expression_737: 'Edit task',
    expression_738: 'Task assigned to',
    expression_739: 'Task created by',
    expression_740: 'You do not have permission to edit this field.',
    expression_741: 'Choose a status...',
    expression_742: 'Delete task',
    expression_743: 'Contact import',
    expression_744: 'Import Rules:',
    expression_745: 'The files must be in .CSV or .XLS (Excel) format and have up to 3 (three) columns:',
    expression_746: 'The "EMAIL" column is optional;',
    expression_747: 'Telephone numbers must follow the international standard (DDI + DDD + Number). Example: 5511988887777',
    expression_748: 'The limit of imported contacts per file is 2 thousand (two thousand) contacts.',
    expression_749: 'Files must have only one "tab" containing the columns described above.',
    expression_750: 'Download model',
    expression_751: 'Import file',
    expression_752: 'We are validating your leads...',
    expression_753: 'We will notify you with a notification once all leads are imported.',
    expression_754: 'Invalid numbers of',
    expression_755: 'Some contacts on your list have an error in the number pattern. You can either upload another file with the necessary corrections or proceed with the import eliminating the invalid numbers.',
    expression_756: 'See the list of problem numbers below.',
    expression_757: 'load another list',
    expression_758: 'Eliminate Invalid Contacts',
    expression_759: 'Line',
    expression_760: 'Error',
    expression_761: 'Great! Now choose which channel and/or tags these leads will be linked to.',
    expression_762: 'We are processing your contacts list.',
    expression_763: 'This may take a while depending on size. Be patient.',
    expression_764: 'Import completed.',
    expression_765: 'It has no numbers or headers have not changed.',
    expression_766: 'Continue import',
    expression_767: 'You need to generate a token with this vendor to integrate.',
    expression_768: 'Get token!',
    expression_769: 'About RD Station CRM',
    expression_770: 'Control your business process and increase sales using RD Station new CRM. It is time to throw the sheets away! Automatically record your actions, never forget to follow-up and centralize everything in one place.',
    expression_771: 'About the Scheduler',
    expression_772: 'Agendor is a CRM and commercial management platform with web and mobile versions (Android and iOS) that works as a control panel for the commercial manager, and a personal sales assistant for B2B sales teams.',
    expression_773: 'About HubSpot',
    expression_774: 'In short, HubSpot CRM is a software that allows you to control the sales process with ease, allowing a complete management of leads, prospects and sales pipeline.',
    expression_775: 'About Nectar CRM',
    expression_776: 'Everything you need for high sales performance! Track your sales opportunities in detail through a visual, intuitive and complete pipeline.',
    expression_777: 'About Pipedrive',
    expression_778: 'Pipedrive is a CRM-like platform created to facilitate sales management for growing companies. The tool is based on selling from activities, so Pipedrive was designed to meet the needs of managers and sellers.',
    expression_779: 'About RBX Soft',
    expression_780: 'The platform is prepared for service packages, multi-companies and franchises. A modular solution that can be customized according to customer needs. The focus is on the constant transformation and logical evolution of the growth of the super competitive and dynamic market.',
    expression_781: 'About Followize',
    expression_782: 'Followize is a lead management software designed to support companies that receive leads over the internet and have difficulty managing new demands from the first contact to the purchase decision.',
    expression_783: 'About BSMS',
    expression_784: 'Integration with BSMS platform.',
    expression_785: 'About API Official Meta',
    expression_786: 'Integration with official WhatsApp API.',
    expression_787: 'About VOIP',
    expression_788: 'Integration with VOIP partner for VoIP calls.',
    expression_789: 'About API',
    expression_790: 'How does this integration work',
    expression_791: 'By integrating your CRM with RDStation you will automatically share your leads information with that supplier. The information that can be sent is the following: Name, Company, Telephone and E-mail.',
    expression_792: 'By integrating your CRM with the Scheduler you will automatically share your leads information with that supplier. The information that can be sent is the following: Name, Telephone and E-mail.',
    expression_793: 'By integrating your CRM with HubSpot you will automatically share your leads information with that supplier. The information that can be sent is the following: Name, E-mail and Telephone.',
    expression_794: 'By integrating your CRM with NectarCRM you will automatically share your leads information with that supplier. The information that can be sent is the following: Name, E-mail and Telephone.',
    expression_795: 'By integrating your CRM with PipeDrive you will automatically share your leads information with that supplier. The information that can be sent is the following: Name, E-mail and Telephone.',
    expression_796: 'By integrating your CRM with RBXSoft you will be able to automatically deliver the slips to your customers by typing CPF or CNPJ corresponding to the registration with your company.',
    expression_797: 'By integrating your CRM with Followize you will automatically share your leads information with that supplier. The information that can be sent is the following: Name, E-mail and Telephone.',
    expression_798: 'Integration not performed! You need to enter the token to proceed.',
    expression_799: 'Download PDF',
    expression_800: 'Differences in logs',
    expression_801: 'Before',
    expression_802: 'Later',
    expression_803: 'Notification Details',
    expression_804: 'View tasks',
    expression_805: 'Mark as read',
    expression_806: 'Mark as unread',
    expression_807: 'This lead already has an open (protocol) protocol.',
    expression_808: 'Search campaign',
    expression_809: 'Final',
    expression_810: 'Clear filters',
    expression_811: 'Search',
    expression_812: 'Channel number',
    expression_813: 'Search for a lead',
    expression_814: 'Initial date',
    expression_815: 'Final date',
    expression_816: 'protocol status',
    expression_817: 'All',
    expression_818: 'Name',
    expression_819: 'Phone',
    expression_820: 'Search for a user',
    expression_821: 'Send HSM message',
    expression_822: 'Template messages are processed individually, with the application of per-send fees.',
    expression_823: 'No template registered.',
    expression_824: 'Edit Variables',
    expression_825: 'Allowed types: MPEG, MP4.',
    expression_826: 'Satisfaction survey',
    expression_827: 'Change user password',
    expression_828: 'Password cannot be empty.',
    expression_829: 'Enter the new password:',
    expression_830: 'Save password',
    expression_831: 'Mass Action in the Portfolio',
    expression_832: 'Choose an action...',
    expression_833: 'Remove leads from wallet',
    expression_834: 'Transfer leads',
    expression_835: 'Remove leads',
    expression_836: 'Available variables',
    expression_837: 'You can use the variables below to dynamically insert information into messages.',
    expression_838: 'Enter the lead name.',
    expression_839: 'Insert the link to subscribe to the campaign channel.',
    expression_840: 'Enter the name of the attendant.',
    expression_841: 'Enter the department name.',
    expression_842: 'Enter the protocol number.',
    expression_843: 'Text Formatting',
    expression_844: 'To format the text of messages, you must add the characters below, before and after each word you want to modify. For example, type:',
    expression_845: 'Result:',
    expression_846: 'asterisk:',
    expression_847: 'He adds',
    expression_848: 'bold',
    expression_849: 'Italic',
    expression_850: 'scratched',
    expression_851: 'to the text.',
    expression_852: 'underline',
    expression_853: 'accent',
    expression_854: 'Media Details',
    expression_855: 'Download',
    expression_856: 'Voip call',
    expression_857: 'Start call',
    expression_858: 'BRL 0.95 per minute',
    expression_859: 'Create main menu',
    expression_860: 'Create submenu',
    expression_861: 'Campaign Details',
    expression_862: 'This campaign was successfully completed!',
    expression_863: 'This campaign is running.',
    expression_864: 'This campaign is scheduled.',
    expression_865: 'Contents',
    expression_866: 'Media',
    expression_867: 'Creation date',
    expression_868: 'Completion date',
    expression_869: 'Campaign created by',
    expression_870: 'Cancel shipping',
    expression_871: 'Do you really want to cancel this campaign?',
    expression_872: 'Yes cancel',
    expression_873: 'Allowed types: JPG, JPEG, PNG, MP4 and PDF.',
    expression_874: 'Choose the department that should receive the protocols.',
    expression_875: 'Choose an attendant to receive protocols.',
    expression_876: 'Type your name:',
    expression_877: 'Enter your email:',
    expression_878: 'Your Whatsapp',
    expression_879: 'I accept to receive promotions.',
    expression_880: 'We received your contact!',
    expression_881: 'We appreciate the interest. Send a message to our WhatsApp.',
    expression_882: 'Do you want to delete this interest?',
    expression_883: 'Do you want to delete this answer?',
    expression_884: 'Error sending message, try again',
    expression_885: 'Do you want to delete this tag?',
    expression_886: 'The maximum size allowed per file is 2MB.',
    expression_887: 'Do you want to delete this link?',
    expression_888: 'This action will delete this tag link with the contact in question.',
    expression_889: 'Enter a note to save.',
    expression_890: 'This action deletes the lead link with the user in question.',
    expression_891: 'Contact added successfully!',
    expression_892: 'Allowed types: JPG, JPEG and PNG.',
    expression_893: 'User created successfully!',
    expression_894: 'Graciously,',
    expression_895: 'Do you want to close this protocol?',
    expression_896: 'Yes, finish',
    expression_897: 'It is only allowed to upload 3 files at a time.',
    expression_898: 'Do you want to delete this goal?',
    expression_899: 'Do you want to delete this task?',
    expression_900: 'Are you sure you want to import',
    expression_901: 'Yes, import',
    expression_902: 'Do you want to delete this notification?',
    expression_903: 'All statuses',
    expression_904: 'Bot successfully registered!',
    expression_905: 'Bot edited successfully!',
    expression_906: 'Deleted!',
    expression_907: 'The bot has been removed.',
    expression_908: 'Canceled!',
    expression_909: 'Campaign deleted successfully.',
    expression_910: 'Campaign created successfully!',
    expression_911: 'Channel edited successfully!',
    expression_912: 'Channel registered successfully!',
    expression_913: 'Protocol transferred successfully!',
    expression_914: 'Protocol successfully completed!',
    expression_915: 'Contact registered successfully',
    expression_916: 'Control Panel',
    expression_917: 'Department successfully registered!',
    expression_918: 'Department successfully edited!',
    expression_919: 'The department was removed.',
    expression_920: 'The campaign was successfully paused.',
    expression_921: 'The campaign was successfully resumed.',
    expression_922: 'This campaign is paused.',
    expression_923: 'Paused',
    expression_924: 'Upload files',
    expression_925: 'deleted!',
    expression_926: '',
    expression_927: 'Messages removed from submission queue!',
    expression_928: 'Interest successfully registered!',
    expression_929: 'Interest edited successfully!',
    expression_930: 'Interest has been removed.',
    expression_931: 'Tag linked successfully!',
    expression_932: 'The tag has been unlinked.',
    expression_933: 'Information changed successfully!',
    expression_934: 'Generating file...',
    expression_935: 'Do not worry, we will let you know with a notification when we are done.',
    expression_936: 'The email informed is not registered in the system.',
    expression_937: 'We send a message to your email. Click on the link in the message to confirm your email address.',
    expression_938: 'Check your mailbox, including trash/spam.',
    expression_939: 'Email sent!',
    expression_940: 'Qualification successfully registered!',
    expression_941: 'Qualification successfully edited!',
    expression_942: 'The qualification has been removed.',
    expression_943: 'Annotation created successfully!',
    expression_944: 'Qualification edited successfully!',
    expression_945: 'The qualification has been removed.',
    expression_946: 'Deleted!',
    expression_947: 'The notification has been removed.',
    expression_948: 'Notifications have been removed.',
    expression_949: 'Operator successfully registered!',
    expression_950: 'The call has been removed.',
    expression_951: 'Export in progress.',
    expression_952: 'Once complete, we will display a notification.',
    expression_953: 'Answer registered successfully!',
    expression_954: 'Answer edited successfully!',
    expression_955: 'The answer has been removed.',
    expression_956: 'Every 13 days you must turn on your device so that WhatsApp keeps your account connected. Otherwise, communication will be interrupted and you will have to repeat the connection process.',
    expression_957: 'Generate QRCode',
    expression_958: 'Success',
    expression_959: 'Tag successfully registered!',
    expression_960: 'Tag edited successfully!',
    expression_961: 'The tag has been removed.',
    expression_962: 'Task successfully registered!',
    expression_963: 'Task edited successfully!',
    expression_964: 'The task has been removed.',
    expression_965: 'Template edited successfully!',
    expression_966: 'Template has been removed.',
    expression_967: 'User has been removed.',
    expression_968: 'User restored successfully!',
    expression_969: 'What do you want to do?',
    expression_970: 'The lead has been removed from the wallet.',
    expression_971: 'Successfully linked wallet!',
    expression_972: 'Contacts have been removed from wallet!',
    expression_973: 'Successfully transferred leads!',
    expression_974: 'Widget edited successfully!',
    expression_975: 'Do you really want to send this campaign?',
    expression_976: 'By clicking Continue, you agree to the',
    expression_977: 'Meta Terms for WhatsApp Business',
    expression_978: 'Continue',
    expression_979: 'Allowed types: JPG, JPEG, PNG and MP4.',
    expression_980: 'of the Department',
    expression_981: 'of the Channel',
    expression_982: 'Page not found.',
    expression_983: 'Back to dashboard',
    expression_984: 'To recover your password, enter the registered email.',
    expression_985: 'Send recovery link by email',
    expression_986: 'Link sent!',
    expression_987: 'We send an email to',
    expression_988: 'with information on how to recover your password. Check your mailbox, including Trash/Spam.',
    expression_989: 'Login',
    expression_990: 'Now, create a new access password:',
    expression_991: 'Save new password',
    expression_992: 'Excellent',
    expression_993: 'Password changed successfully!',
    expression_994: 'Password too short.',
    expression_995: 'Do you want to delete this lead from the wallet?',
    expression_996: 'Do you want to delete this attendant?',
    expression_997: 'It is not allowed to change the access level when there is an attendant link in any channel.',
    expression_998: 'Change Password',
    expression_999: 'Logs',
    expression_1000: 'Linked Channels',
    expression_1001: 'Click on the channel name to link this user',
    expression_1002: 'This user does not have access to any channel yet.',
    expression_1003: 'Activity Logs',
    expression_1004: 'Origin ID',
    expression_1005: 'Differences',
    expression_1006: 'IP address',
    expression_1007: 'See differences',
    expression_1008: 'No logs recorded for this user.',
    expression_1009: 'Contacts Wallet',
    expression_1010: 'Bulk action',
    expression_1011: 'No leads registered in the wallet.',
    expression_1012: 'Availability',
    expression_1013: 'Remove user',
    expression_1014: 'Online',
    expression_1015: 'Offline',
    expression_1016: 'In',
    expression_1017: 'departments/channels',
    expression_1018: 'No users have been registered so far.',
    expression_1019: 'Do you want to delete this user?',
    expression_1020: 'January',
    expression_1021: 'February',
    expression_1022: 'March',
    expression_1023: 'April',
    expression_1024: 'May',
    expression_1025: 'June',
    expression_1026: 'July',
    expression_1027: 'August',
    expression_1028: 'September',
    expression_1029: 'October',
    expression_1030: 'November',
    expression_1031: 'December',
    expression_1032: 'Today',
    expression_1033: 'Month',
    expression_1034: 'Week',
    expression_1035: 'Day',
    expression_1036: 'List',
    expression_1037: 'No tasks scheduled for that date.',
    expression_1038: 'Email Report',
    expression_1039: 'HSM Shipping Report',
    expression_1040: 'SMS report',
    expression_1041: 'VoIP Calls Report',
    expression_1042: 'Search emails',
    expression_1043: 'No emails have been sent so far.',
    expression_1044: 'Search HSM',
    expression_1045: 'No HSM has been sent so far.',
    expression_1046: 'Search SMS',
    expression_1047: 'No SMS has been sent so far.',
    expression_1048: 'Search Voip',
    expression_1049: 'No calls have been made so far.',
    expression_1050: 'Distribute leads evenly to your agents.',
    expression_1051: 'and',
    expression_1052: 'Survey Report',
    expression_1053: 'Photos and videos',
    expression_1054: 'Opening fee',
    expression_1055: 'No data available.',
    expression_1056: 'Status (beta)',
    expression_1057: 'Webhooks',
    expression_1058: 'Tokens',
    expression_1059: 'Add token',
    expression_1060: 'Received messages',
    expression_1061: 'Message status',
    expression_1062: 'Inform the webhook that you will receive messages from your channel.',
    expression_1063: 'Inform the webhook that you will receive status messages.',
    expression_1064: 'Payload Examples',
    expression_1065: 'See payload examples',
    expression_1066: 'Expiration',
    expression_1067: 'Token',
    expression_1068: 'Never',
    expression_1069: '7 days',
    expression_1070: '24 hours',
    expression_1071: '12 hours',
    expression_1072: '4 hours',
    expression_1073: 'Edit token',
    expression_1074: 'Token successfully copied!',
    expression_1075: 'Choose a token expiration period...',
    expression_1076: 'Click to copy this token',
    expression_1077: 'Do you want to delete this token?',
    expression_1078: 'Timeline',
    expression_1079: 'Expired',
    expression_1080: 'Deadline',
    expression_1081: 'Copy',
    expression_1082: 'Congratulations! You have imported a valid list.',
    expression_1083: 'Proceed with import',
    expression_1084: 'To send a contact on',
    expression_1085: 'use the international numeric standard, including DDI (country code) and DDD (for example: 5511988888888), without spaces or any other character types. If the contact does not have WhatsApp, the number will be sent only as a text.',
    expression_1086: 'Send vCard',
    expression_1087: 'Send',
    expression_1088: 'Closed',
    expression_1089: 'Transferred',
    expression_1090: 'Rejected',
    expression_1091: 'Operator inactivity',
    expression_1092: 'Contact inactivity',
    expression_1093: 'System message',
    expression_1094: 'For more information on how to integrate via API, ',
    expression_1095: 'click here to read the documentation.',
    expression_1096: 'You',
    expression_1097: 'Answer',
    expression_1098: 'Critical use of the system',
    expression_1099: 'You have many open calls! This can cause slow system usage due to the amount of information being processed on your computer. For healthy use of the system, we strongly advise you to close open protocols.',
    expression_1100: 'No linked channels',
    expression_1101: 'Linked channel',
    expression_1102: 'Migration',
    expression_1103: 'Migrate this channel to another deploy',
    expression_1104: 'Subdomain',
    expression_1105: 'Domain',
    expression_1106: 'Channel ID',
    expression_1107: 'Migration started! We\'ll send you a notification when we\'re done.',
    expression_1108: 'This action is irreversible and will remove the tokens from the current WhatsApp session.',
    expression_1110: 'See conversation',
    expression_1111: 'You have a new message!',
    expression_1112: 'sent you a new message!',
    expression_1113: 'Internal chat',
    expression_1114: 'This protocol is already being serviced or finalized.',
    expression_1115: 'Attention: If you want to import international numbers, please only import a list containing the numbers from that specific country. You should not mix contacts from different countries in the same list.',
    expression_1116: 'None',
    expression_1117: 'CHANNEL RANKING',
    expression_1118: 'DEPARTMENT RANKING',
    expression_1119: 'ATTENDANT RANKING',
    expression_1120: 'Enter the URL here...',
    expression_1121: 'Campaigns by Broadcast List',
    expression_1122: 'Campaigns by Status',
    expression_1123: 'Inform the webhook that you will receive the status of campaigns in this mode of delivery.',
    expression_1124: 'Searchs',
    expression_1125: 'at',
    expression_1126: 'No message',
    expression_1127: 'Download file...',
    expression_1128: 'Change file',
    expression_1129: 'This functionality is in the testing phase.',
    expression_1130: 'You cannot enable this module if the API is enabled.',
    expression_1131: 'You cannot enable this module if Chat-bot or Notifications is enabled.',
    expression_1132: 'To make the best use of the API, you may need the help of a qualified professional. Chat-Bot and Notifications modules cannot work while this module is enabled. See our API documentation for more information.',
    expression_1133: 'No token has been registered.',
    expression_1134: 'The contact must have communicated with the channel previously. In addition to the mandatory fields, RD Station needs the “Company” information to register the Contact. Therefore, if the Contact has this field filled in in the CRM, we will send this information. Otherwise, we will send your channel type in place of the “Company” field. For example: “WhatsApp - ',
    expression_1135: 'Important report.',
    expression_1136: 'As already guided by the Support team of',
    expression_1137: 'due to the high flow of mass sending WhatsApp has been restricting more and more and blocking for this reason.',
    expression_1138: 'Be careful not to file complaints or block your accounts due to excessive use of this feature.',
    expression_1139: 'Whenever possible, he would read our tips before doing a postage to improve his performance.',
    expression_1140: 'In case of doubt, please contact us with our support.',
    expression_1141: 'Ok, I understand!',
    expression_1142: 'Functionality temporarily disabled.',
    expression_1143: 'Countries',
    expression_1144: 'States',
    expression_1145: 'Cities',
    expression_1146: 'Running',
    expression_1147: 'Devices',
    expression_1148: 'Visits',
    expression_1149: 'Campaign Traffic Report',
    expression_1150: 'Campaign Summary',
    expression_1151: 'See details',
    expression_1152: 'Campaign name',
    expression_1153: 'Total Visits',
    expression_1154: 'per day',
    expression_1155: 'Unique visitors',
    expression_1156: 'Browsers',
    expression_1157: 'Operational systems',
    expression_1158: 'Contact removed successfully!',
    expression_1159: 'Are you sure you want to delete this contact?',
    expression_1160: 'Delete Contact',
    expression_1161: 'Connection with Telegram',
    expression_1162: 'Scan the QR-Code to connect your WhatsApp account',
    expression_1163: '1) Open WhatsApp on your mobile.',
    expression_1164: '2) Access',
    expression_1165: '"More Options" or "Settings" and select "Connected Devices".',
    expression_1166: '3) Point your phone at this screen to capture the code.',
    expression_1167: 'Send code via SMS',
    expression_1168: 'Confirm phone number',
    expression_1169: 'You will receive an SMS with the verification code at the number below:',
    expression_1170: 'Enter verification code',
    expression_1171: 'You will receive a code via SMS. Enter this code below:',
    expression_1172: 'Setting up environment...',
    expression_1173: 'Your code has been successfully validated! Now, we are preparing your environment. This may take a few moments.',
    expression_1174: 'Your account is connected!',
    expression_1175: 'Congratulations! Now you can communicate via Telegram within our CRM.',
    expression_1176: 'We have lost connection to your Telegram account.',
    expression_1177: 'If it persists, contact our support.',
    expression_1178: 'Telegram connection',
    expression_1179: 'Traffic Monitoring',
    expression_1180: 'Enable this functionality to generate a shortened link and add tracking codes to your campaign.',
    expression_1181: 'The monitoring is only available for campaigns containing files. Add a file with the previous card: Conteúdo da Campanha',
    expression_1182: 'Add a file',
    expression_1183: 'Disable',
    expression_1184: 'Activate',
    expression_1185: 'Link Title',
    expression_1186: 'This title will appear alongside the image thumbnail in the shared link.',
    expression_1187: 'Google Analytics Code',
    expression_1188: 'Example Metric ID: G-TWNTT9BWDL.',
    expression_1189: 'Google Tag Manager Code',
    expression_1190: 'Example Metric ID: G-TWNTT9BWDL.',
    expression_1191: 'Facebook Pixel Code',
    expression_1192: 'Pixel ID example: 1049737222095654.',
    expression_1193: 'Choose a broadcast channel',
    expression_1194: 'You need to create a broadcast channel to generate your campaigns!',
    expression_1195: 'Insert the link to your WhatsApp channel.',
    expression_1196: 'WhatsApp Connection',
    expression_1197: 'Send HSM',
    expression_1198: 'HSM Template List Synced Successfully!',
    expression_1199: 'Session',
    expression_1200: 'Delivered',
    expression_1201: 'Read',
    expression_1202: 'Not sent',
    expression_1203: 'File name',
    expression_1204: 'Insufficient text space',
    expression_1205: 'Could not add variable',
    expression_1206: 'because there is no text space.',
    expression_1207: 'Payload preview',
    expression_1208: 'Example',
    expression_1209: 'Webhooks Report',
    expression_1210: 'Search Webhooks',
    expression_1211: 'Logs webhooks',
    expression_1212: 'No Webhook has been sent yet.',
    expression_1213: 'Official API feedback',
    expression_1214: 'Payload',
    expression_1215: 'Resend',
    expression_1216: 'Message forwarded!',
    expression_1217: 'A new submission has been made to the official API.',
    expression_1218: 'Contact(s) sent',
    expression_1219: 'Unable to verify that the lead already exists in the channel, please select again.',
    expression_1220: 'Create send group',
    expression_1221: 'Sending groups management',
    expression_1222: 'Groups',
    expression_1223: 'All groups',
    expression_1224: 'Delete group',
    expression_1225: 'channels found',
    expression_1226: 'New group',
    expression_1227: 'Selected group',
    expression_1228: 'Group\'s name',
    expression_1229: 'Are you sure you want to delete this group ?',
    expression_1230: 'Create group',
    expression_1231: 'Select a group',
    expression_1232: 'Edit group name',
    expression_1233: 'Back to group selection',
    expression_1234: 'Group created successfully!',
    expression_1235: 'Group successfully removed!',
    expression_1236: 'Channel added successfully!',
    expression_1237: 'Sending groups are used to organize small groups of named channels in order to facilitate the recipients of your campaigns.',
    expression_1238: 'Manage this tool and enjoy its features.',
    expression_1239: 'What is a sending group?',
    expression_1240: 'Official Channels cannot be included in groups!!',
    expression_1241: 'Created',
    expression_1242: '-> User ID #{id} does not have access to this channel. Please check with support!',
    expression_1243: 'It is not possible to disconnect from the channel without first deleting the attendant.',
    expression_1244: 'Hold',
    expression_1245: 'The template has been sent for deletion, wait for Meta\'s response. If the deletion does not occur immediately, synchronize by clicking on the "Synchronize templates" button.',
    expression_1246: 'Sync templates',
    expression_1247: 'Hide other languages',
    expression_1248: 'Hide or show non-system language templates',
    expression_1249: 'View other languages',
    expression_1250: "Please, select a sheet of type .csv, .xls ou .xlsx",
    expression_1251: "Chatbot Traffic Report",
    expression_1252: "Current month clicks",
    expression_1253: "Clicks",
    expression_1254: "Welcome to your chatbot clicks report",
    expression_1255: "To view statistics, select a channel",
    expression_1256: "Chatbot levels",
    expression_1257: "See main level",
    expression_1258: "Chatbot click Statistics",
    expression_1259: "Channel does not have click-to-view information",
    expression_1260: "Select another channel",
    expression_1261: "Report",
    expression_1262: 'Click filter',
    expression_1263: "WhatsApp Web QR (unofficial)",
    expression_1264: "You are not allowed to change.",
    expression_1265: 'About WhatsApp Web',
    expression_1266: 'Integration with unofficial WhatsApp Web.', /*Sem referência para seu contexto*/
    expression_1267: 'Disconnect',
    expression_1268: 'Disconnected session', /*Sem referência para seu contexto*/
    expression_1269: 'Connected!',
    expression_1270: 'Unable to enable because "Official Meta API" is enabled.',
    expression_1271: 'Unable to enable because "QR Code" is enabled.',
    expression_1272: 'Open book',
    expression_1273: 'Close book',
    expression_1274: 'No filters other than channel selected for search',
    expression_1275: 'Connect',
    expression_1276: 'Disconnected!',
    expression_1277: 'Register your campaign or export reports',
    expression_1278: "Enable and configure an integration in \"Channels\"",
    expression_1279: "Generate Secret",
    expression_1280: "You need to have a valid token to integrate.",
    expression_1281: "Disconnect with WhatsApp Business API to integrate with WhatsApp",
    expression_1282: "Disconnect with WhatsApp to integrate with WhatsApp Business API",
    expression_1283: "There was an error generating your secret",
    expression_1284: "Token and Secret generated successfully",
    expression_1285: "Select all channels",
    expression_1286: "Unselect all channels",
    expression_1288: "Content of Subtitle",
    expression_1289: 'Continue',
    expression_1290: 'Online Agents',
    expression_1291: 'Agents',
    expression_1292: 'Completed Conversations',
    expression_1293: 'Completed',
    expression_1294: 'Conversations',
    expression_1295: 'Unfinished Conversations',
    expression_1296: 'Messages',
    expression_1297: 'Overdue Business',
    expression_1298: 'Overdue',
    expression_1299: 'Sales Cycle',
    expression_1300: 'Cycle',
    expression_1301: 'Days',
    expression_1302: 'Volume of Opportunities',
    expression_1303: 'Volume',
    expression_1304: 'Sales Conversion (30 days)',
    expression_1305: 'Earnings',
    expression_1306: "User interaction and engagement metrics",
    expression_1307: "Campaign performance and email metrics",
    expression_1308: "Service message reports",
    expression_1309: "Net Promoter Score and customer satisfaction",
    expression_1310: "Performance and productivity metrics",
    expression_1311: "SMS sending and delivery statistics",
    expression_1312: "Call and voice communication reports",
    expression_1313: "Conversation and interaction analysis",
    expression_1314: "Webhook monitoring and analysis",
    expression_1315: "Chatbot and self-service metrics",
    expression_1316: "Opportunity and conversion analysis",
    expression_1317: "View and analyze important data to make strategic decisions",
    expression_1318: "Boost Your Relationships",
    expression_1319: "Access Bee CRM and turn data into valuable connections with your clients.",
    expression_1319_wl: "Access the CRM and turn data into valuable connections with your customers.",
    expression_1320: "Smart Management",
    expression_1321: "Centralize contacts, automate tasks, and track opportunities in real-time.",
    expression_1322: "Accelerated Productivity",
    expression_1323: "Reduce time on manual tasks and focus on what really matters: your clients.",
    expression_1324: "Guaranteed Security",
    expression_1325: "Your data protected with advanced encryption and personalized access controls.",
    expression_1326: "Complete Integration",
    expression_1327: "Connect with your favorite tools and unify your business processes.",
    expression_1328: "By continuing, you agree to the",
    expression_1328_wl: "By continuing, you agree to our Terms of Service.",
    expression_1329: "Terms of Service",
    expression_1330: "of Bee CRM.",
    expression_1331: "Welcome back!",
    expression_1332: "Log in with your credentials to access your account",
    expression_1333: "Your corporate email",
    expression_1334: "Your password",
    expression_1335: "Recover Access",
    expression_1336: "Recover your Access",
    expression_1337: "Reset your password quickly and securely to start managing your relationships again.",
    expression_1338: "Advanced Security",
    expression_1339: "Process protected by encryption and multi-step verification.",
    expression_1340: "Quick Process",
    expression_1341: "Recover your access in just a few minutes and get back to using the system.",
    expression_1342: "Secure Confirmation",
    expression_1343: "Receive detailed instructions directly in your registered email.",
    expression_1344: "New Credential",
    expression_1345: "Create a strong new password to protect your data and information.",
    expression_1346: "Your password has been successfully changed. You can now log in with your new password.",
    expression_1347:"View notifications for reports or system updates.",
    expression_1348: "Messages and Notifications",
    expression_1349: "Account Management",
    expression_1350:"In development",
    expression_1351: "Mark all as read",
    expression_1352: "Mark all as unread",
    /*TRADUCOES Channel_Flow*/
    /*TRADUCOES CompanyInformation*/
    expression_1353: "Company Name",
    expression_1354: "Added Teams",
    expression_1355: "Remove team",
    expression_1356: "Industry Sector",
    expression_1357: "Select your company’s sector",
    expression_1358: "Fill in your company’s basic information to start the registration of the",
    expression_1359:"This data will be used to configure and identify your channel.",
    expression_1360: "Enter the team name.",
expression_1361: "This team has already been added.",
expression_1362: "Enter the company name.",
/*TRADUCOES TITLES*/
expression_1363: "Select the Channel",
expression_1364: "Company Information",
expression_1365: "User Registration",
expression_1366: "Channel Activation",
expression_1367: "Confirmation",
expression_1368: "Next",

  /*TRADUCOES Avisos*/
  expression_1369: "Select a channel to continue.",
expression_1370: "The company name is required!",
expression_1371: "Add at least one team before continuing.",
expression_1372: "Add at least one user.",

expression_1373: "🎉 Registration Completed! 🎉",
expression_1374: "Your registration has been successfully completed!",
expression_1375: "Close",

/*TRADUCOES USERS*/
expression_1376: "Now, let's register the user who will have access to the channel. Set the name, email, password, and role.",
expression_1377: "Enter the user's email",
expression_1378: "Enter the user's full name",
expression_1379: "Administrators cannot be linked to teams.",
expression_1380: "Select the team",
expression_1381: "Added users:",
expression_1382: "This email has already been added.",
expression_1383: "This email already exists in the system.",
expression_1384: "Error verifying email.",
expression_1385: "Please fill in all required fields.",
expression_1386: "Invalid email.",
expression_1387: "The email format is invalid.",
expression_1388: "added successfully!",
expression_1389: "User removed successfully.",
expression_1390: "Responsible for sending, receiving messages, and managing your business.",
expression_1391: "Full access to manage settings, users, and messages.",
expression_1392: "Can manage messages and settings, but not users.",
expression_1393: "Remove user",
expression_1394: "User",
/*TRADUCOES CHANNEL - Activation*/
expression_1395: "Click below to activate your channel right now. Then, click on \"Activate Channel\".",
expression_1396: "Channel successfully activated!",
expression_1397: "Something went wrong during activation. Please try again.",
expression_1398: "Error activating channel:",
expression_1399: "Unexpected error while activating channel.",
expression_1400: "Activate Channel",
expression_1401: "Activation in progress...",
expression_1402: "Select a communication channel",
/*Ajuda*/
expression_1403: "Help Center",
expression_1404: "Bee Support",
expression_1405: "Bee Blog",
expression_1406: "Privacy Policy",

expression_1407: "Select a tag to add",
expression_1408: "Update",
expression_1409: "View less",
expression_1410: "Custom Fields",
expression_1411: "No custom fields available",
expression_1412: "Enter the value for",
expression_1413: "Opportunity",
expression_1414: "Valor",
expression_1415: "Please select a channel first",
expression_1416: "Select a channel to view the custom fields",
expression_1417: "There are no custom fields available for this channel",
expression_1418: "Add Field",
expression_1419: "All fields",
expression_1420: "Selected Fields",
expression_1421: "No field selected",
expression_1422: "General Filters",
expression_1423: "Field updated",
expression_1424: "Error updating field:",
expression_1425: "Error saving field",
expression_1426: "Failed to update value",
expression_1427: "Failed to load custom fields",
expression_1428: "Failed to update email",
expression_1429: "Email updated!",
expression_1430: "Name updated!",
expression_1431: "Could not update the name",
expression_1432: "Newsletter updated!",
expression_1433: "Unable to update subscription",
expression_1434: "No opportunity found",
expression_1435: "Searching leads...",
expression_1436: "No leads found with the current filters.",
expression_1437: "I confirm that we have obtained proper consent to send SMS, email, or other types of messages to the contacts being created or imported, in compliance with applicable laws and regulations.",
expression_1438: "You need to accept the terms to continue.",
expression_1439: 'Field Name',
expression_1440: 'Field Type',
expression_1441: 'New Field',
expression_1442: 'Actions',
expression_1443: 'Active',
expression_1444: 'Archived',
expression_1445: 'Select Channel',
expression_1446: 'Select a channel to view custom fields',
expression_1447: 'Confirm the deletion of the attribute and its information?',
expression_1448: 'This action cannot be undone and all associated data will be lost.',
expression_1449: 'Delete Attribute',
expression_1450: 'Manage your preferences and customizations',
expression_1451: 'Edit Field',
expression_1452: 'Field created successfully',
expression_1453: 'Field updated successfully',
expression_1454: 'Options',
expression_1455: 'Add Option',
expression_1456: 'Create Field',
expression_1457: 'No field found for',
expression_1458: 'No custom field created for this channel',
expression_1459: 'Create First Field',
expression_1460: 'Field Name',
expression_1461: 'Field archived successfully',
expression_1462: 'Field unarchived successfully',
expression_1463: 'A field with this name already exists',
expression_1464: 'Add at least one option for the select field',
expression_1465: 'The field name is required',
expression_1466: 'The field name must be at most 30 characters long',
expression_1467: 'Select a channel before saving the field',
expression_1468: 'Field',
expression_1469: 'deleted successfully',
expression_1470: 'Clear all',
expression_1471: 'Latest negotiations',
expression_1472: 'Budget',
expression_1473: "Protocol copied:",
expression_1474: "Copied!",
expression_1475: "Schedule",
// expression_1476: "Hello! Your WhatsApp chat session has ended. To start a new conversation, select a message template by clicking",
// expression_1477: "here",
expression_1478: "New Opportunity",
expression_1479: "New Proposal",
expression_1480: "No purchase registered",
expression_1481: "Search",
expression_1482: "Type something to search contacts",
expression_1483: "Use the search field above.",
expression_1484: "No contacts found",
expression_1485: "Try using different terms or check if the contact is registered in the system.",
expression_1486: "Subscribed",
expression_1487: "Unsubscribe",
expression_1488: "Not subscribed",
expression_1489: "(Subscribe)",
expression_1490: "Chats and support",
expression_1491: "HSM Templates",
expression_1492: "Media",
expression_1493: "Hide lead details",
expression_1494: "Show lead details",
expression_1495: "Loading messages. Please wait.",
expression_1496: "Select channel",
expression_1497: "Choose the tags to segment your audience", 
expression_1498: "Select the tags...", 
expression_1499: "Select Template Message",
expression_1500: "Choose Template Message",
expression_1501: "All",
expression_1502: "Clear",
expression_1503: "of",
expression_1504: "selected",
expression_1505: "Fill in the personalized information",
expression_1506: "System Variables",
expression_1507: "Click a variable to insert into the text",
expression_1508: "Sending Options",
expression_1509: "Select a template above.",
expression_1510: "Choose a PDF file",
expression_1511: "Choose a JPG or PNG file",
expression_1512: "Template message",
expression_1513: "Time",
expression_1514: "Recommended times",
expression_1515: "Posts can only be shared between 20 minutes and 29 days after being created.",
expression_1516: "Best times for engagement",
expression_1517: "Based on user behavior studies",
expression_1518: "No models found for",
expression_1519: "Try using different terms or check the spelling.",
expression_1520: "Searching for template",

    divisor: '_______________________________',
    tags: 'Tags',
    departments: 'Departments',
    histories: 'Messages (API)',
    interests: 'Interests',
    motives: 'Protocol Qualification',
    operators: 'Operators',
    replies: 'Quick Answers',
    sources: '',
    users: 'Users',
    widget: 'Widget'
  },
  getters: {
    getTranslationEn: () => (key) => {
      return key.en
    },
  },
}
export default en;
